import request from '@/utils/request'


//查询任务设置
export function activitySetting(data) {
  return request({
    url: '/admin/activitySetting/search',
    method: 'post',
    data: data
  })
}

export function addStoreLevelActivity(data) {
  return request({
    url: '/admin/activitySetting/addStoreLevelActivity',
    method: 'post',
    data: data
  })
}

export function delStoreLevelActivity(params) {
  return request({
    url: '/admin/activitySetting/deleteStoreLevelActivity',
    method: 'get',
    params: params
  })
}
export function uploadAudio(data) {
  return request({
    url: '/upload/common/uploadAudio',
    method: 'post',
    data: data
  })
}
export function storeWxPay(data) {
  return request({
    url: '/admin/store/wxPay',
    method: 'post',
    data: data
  })
}
export function getPayStatu(params) {
  return request({
    url: '/admin/store/getPayStatu',
    method: 'get',
    params: params
  })
}
export function storeFrontAuditPage(data) {
  return request({
    url: '/admin/frontAudit/storeFrontAuditPage',
    method: 'post',
    data: data
  })
}
export function examineFrontAudit(params) {
  return request({
    url: '/admin/frontAudit/examineFrontAudit',
    method: 'get',
    params: params
  })
}
export function updStoreFrontAudit(data) {
  return request({
    url: '/admin/frontAudit/updStoreFrontAudit',
    method: 'post',
    data: data
  })
}
export function delStoreFrontAudit(params) {
  return request({
    url: '/admin/frontAudit/delStoreFrontAudit',
    method: 'get',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/ActivitySetting.js